import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/store";
import vuetify from "./plugins/vuetify";
import FirebaseApp from "../firebaseApp";
import "chart.js";
import "hchs-vue-charts";
import './registerServiceWorker'
import 'material-design-icons-iconfont/dist/material-design-icons.css'



Vue.use(window.VueCharts);

Vue.config.productionTip = false;

Vue.filter("changePoint", {
  read: function(val) {
    return val;
  },
  write: function(val) {
    return val;
  }
});

let app;
const init = () => {
  if (!app) {
    app = new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  }
};

FirebaseApp.auth().onAuthStateChanged(async user => {
  if (user) {
    await store.commit("auth/setUser", user);
    store.dispatch("dietsBase/index");
    store.dispatch("history/index");
  } else {
    store.commit("auth/setUser", null);
  }
  init();
});
